import React from "react";
import {
  userDirectoryLoginAllowed,
  userAccountStatusLabel,
  normalizeUserAccountStatus,
  USER_ACCOUNT_STATUS,
} from "../../../../utils/userAccountStatus";

const PartnerReviewAlerts = ({ partner, user }) => {
  const showTcRejected = partner?.tcApprovalStatus === "rejected";
  const showPartnerInactive = partner?.status === "inactive";
  const showUserBlocked = user && !userDirectoryLoginAllowed(user);

  if (!showTcRejected && !showPartnerInactive && !showUserBlocked) return null;

  const userStatusLine = () => {
    if (!user || userDirectoryLoginAllowed(user)) return null;
    const s = normalizeUserAccountStatus(user.status);
    const label = userAccountStatusLabel(user.status);
    const activeFlagOff = user.active === false && s === USER_ACCOUNT_STATUS.ACTIVE;
    return (
      <li>
        Primary account (login) is <strong>{label}</strong>
        {activeFlagOff ? " (access revoked)" : ""}
        {s === USER_ACCOUNT_STATUS.BANNED && user.banReason ? (
          <>
            {" "}
            — <span className="text-danger">Reason: {user.banReason}</span>
          </>
        ) : null}{" "}
        — distinct from partner workflow status.
      </li>
    );
  };

  return (
    <div className="alert alert-warning mb-3" role="alert">
      <strong className="d-block mb-1">Review before changing teleconsultation or visibility</strong>
      <ul className="mb-0 ps-3 small">
        {showTcRejected ? (
          <li>
            Partner teleconsultation approval is <strong>rejected</strong>. Re-approving requires an explicit decision.
          </li>
        ) : null}
        {showPartnerInactive ? (
          <li>
            Partner workflow status is <strong>inactive</strong>.
          </li>
        ) : null}
        {showUserBlocked ? userStatusLine() : null}
      </ul>
    </div>
  );
};

export default PartnerReviewAlerts;
